import { useContext } from "react";
import { useHistory } from "react-router-dom";
import { Layout, Menu } from "antd";
import { Context } from "./Context";
import CarrierLogo from "./assets/CarrierLogo";

const { Content, Sider } = Layout;

const items = [
  {
    key: "home",
    path: "/home",
    label: "Home",
  },
  {
    key: "manage-feature-flags",
    path: "/manage-feature-flags",
    label: "Manage Feature Flags",
  },
  {
    key: "provisioning-status",
    path: "/provision-status",
    label: "Provisioning Status",
  },
  {
    key: "update-mac-pin",
    path: "/update-mac-pin",
    label: "Update Mac Pin",
  },
  {
    key: "provision-device",
    path: "/provision-device",
    label: "Provision The Device",
  },
];

const Nav = ({ children }) => {
  const history = useHistory();
  const context = useContext(Context);
  const accessToken = localStorage.getItem("accessToken");

  const filteredItems = items.filter((item) => {
    if (accessToken !== null)
      return ["home", "update-mac-pin", "provision-device"].includes(item.key);
    else
      return ["home", "manage-feature-flags", "provisioning-status"].includes(
        item.key,
      );
  });

  const handleMenuClick = ({ key }) => {
    const item = filteredItems.find((item) => item.key === key);
    context.setNavActiveKey(item.key);
    history.push(item.path);
  };

  return (
    <Layout className="min-vh-100">
      <Sider className="sider">
        <div className="d-flex justify-content-center m-1">
          <div className="w-75">
            <CarrierLogo />
          </div>
        </div>

        <Menu
          theme="dark"
          defaultSelectedKeys={["home"]}
          selectedKeys={[context.navActiveKey]}
          mode="inline"
          items={filteredItems.map((item) => ({
            key: item.key,
            label: item.label,
          }))}
          onClick={handleMenuClick}
        />
      </Sider>

      <Layout>
        <Content>{children}</Content>
      </Layout>
    </Layout>
  );
};

export default Nav;
